import React, { useState, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
import styles from "../Dashboard.module.css";
import {
  Typography,
  Button,
  TextField,
  Paper,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Collapse,
  FormControlLabel,
  Switch,
  Box,
  Tooltip
  } from "@mui/material";
  import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FilterList } from "@mui/icons-material";
import api from "../../../API/axios";
import NotificationSnackbar from "../../../components/NotificationSnackbar";
import useNotification from "../../../hooks/useNotification";
import { useAuthApi } from "../../../hooks/useAuthApi";
import { Cancel } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { useRoleNavigator } from "../../../utils/roleNavigator";
import { useOperatorsApi } from "../../../hooks/useOperatorsApi";

export default function OperatorList() {
  const { resendVerificationEmail } = useAuthApi();
  const { loading, operators, fetchOperators } = useOperatorsApi();

  const navigateByRole = useRoleNavigator();
  // State for analytics configuration from backend
  const [sentMessagesDays, setSentMessagesDays] = useState(7);
  // Sorting state for grid columns
  // const [sortBy, setSortBy] = useState('name');
  // const [sortDir, setSortDir] = useState('asc');
  // Helper to determine status for operator
  function getStatus(operator) {
    // Show status directly from registrationStatus, capitalized
    const regStatus = (operator.registrationStatus || "").trim();
    return regStatus.charAt(0).toUpperCase() + regStatus.slice(1).toLowerCase();
  }
  // const navigate = useNavigate();
  const [filteredOperators, setFilteredOperators] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
    ownerClient: "",
    group: "",
  });
  const [statusFilter, setStatusFilter] = useState("Disable");
  // Add Operator Modal
  const [showAddModal, setShowAddModal] = useState(false);
  const [clients, setClients] = useState([]);
  const [newOperator, setNewOperator] = useState({
    name: "",
    email: "",
    ownerClientId: "",
    payoutAmount: "",
  });
  const [errors, setErrors] = useState({});

  const { notification, showNotification, hideNotification } =
    useNotification();

  useEffect(() => {
    fetchOperators();
    fetchClients();
    fetchAnalyticsConfig();
  }, []);

  useEffect(() => {
    filterOperators();
  }, [operators, searchTerm]);

  // Fetch analytics configuration from backend
  const fetchAnalyticsConfig = async () => {
    try {
      const response = await api.get("/config/analytics");
      const days = response.data?.sentMessagesDays || 7;
      setSentMessagesDays(days);
    } catch (err) {
      console.error("Failed to fetch analytics config, using default:", err);
      setSentMessagesDays(7); // Default to 7 days
    }
  };

  const fetchClients = async () => {
    try {
      const response = await api.get("/clients");
      const clientData = response.data?.data || response.data || [];
      setClients(Array.isArray(clientData) ? clientData : []);
    } catch (err) {
      console.error("Failed to fetch clients:", err);
      setClients([]);
    }
  };

  const filterOperators = () => {
    let filtered = operators.filter((operator) => {
      const matchesSearch =
        operator.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        operator.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        operator.uniqueId?.toString().includes(searchTerm);

      return matchesSearch;
    });
    setFilteredOperators(filtered);
  };

  const handleAddOperator = async () => {
    const newErrors = {};
    if (!newOperator.name.trim()) newErrors.name = "Name is required";
    if (!newOperator.email.trim()) newErrors.email = "Email is required";
    if (!newOperator.ownerClientId)
      newErrors.ownerClientId = "Owner client is required";
    if (newOperator.payoutAmount && parseFloat(newOperator.payoutAmount) < 0)
      newErrors.payoutAmount = "Payout amount cannot be negative";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      showNotification("Please fix validation errors", "error");
      return;
    }

    try {
      const payload = {
        name: newOperator.name,
        email: newOperator.email,
        ownerClientId: newOperator.ownerClientId,
        payoutAmount: newOperator.payoutAmount ? parseFloat(newOperator.payoutAmount) : 0,
        role: "Operator",
      };
      await api.post("/operators", payload);
      showNotification("Operator created successfully", "success");
      setShowAddModal(false);
      setNewOperator({
        name: "",
        email: "",
        ownerClientId: "",
        payoutAmount: "",
      });
      setErrors({});
      fetchOperators();
    } catch (err) {
      if (err.response.data === "Email already exists.") {
        showNotification(err.response.data, "error");
      } else {
        console.error("Failed to create operator:", err);
        showNotification("Failed to create operator", "error");
      }
    }
  };

  const handleEditOperator = (operatorId) => {
    // navigate(`/superadmin/operators/${operatorId}/edit`);
    navigateByRole(`operators/${operatorId}/edit`);
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      sortable: true,
    },
    {
      field: "email",
      headerName: "Email",
      width: 250,
      sortable: true,
      cellClassName: "email-cell",
    },
   {
  field: "numberOfSentMessages",
  headerName: "Sent Messages",
  width: 150,
  sortable: true,
  align: "center",
  headerAlign: "center",
  cellAlign: "center",
  
  renderHeader: () => (
    <Tooltip 
      title={`Number of sent messages in last ${sentMessagesDays} days`}
      arrow 
      placement="top"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          cursor: "pointer",
          width: "100%",
        }}
      >
        <span>Sent Messages</span>
        <InfoOutlinedIcon fontSize="small" />
      </Box>
    </Tooltip>
  ),
  renderCell: (params) => (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {params.value || "-"}
      </Typography>
    </Box>
  ),
}


   
,
    {
      field: "registrationStatus",
      headerName: "Status",
      width: 150,
      sortable: true,
      renderCell: (params) => {
        const status = getStatus(params.row);
        const color =
          status === "Enable" || status === "Active"
            ? "success"
            : status === "Pending"
            ? "warning"
            : "error";
        return <Chip label={status} color={color} size="small" />;
      },
    },
    
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleEditOperator(params.row.id)}
          style={{ color: "var(--color-icon)" }}
          size="small"
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "resend",
      headerName: "Resend Invite",
      width: 160,
      sortable: false,
      renderCell: (params) => {
        const status = getStatus(params.row);
        if (status === "Pending" || status === "Invited") {
          return (
            <IconButton
              color="primary"
              size="small"
              title="Resend Invite"
              onClick={async (e) => {
                e.stopPropagation();
                const result = await resendVerificationEmail(params.row.id);
                if (result) {
                  showNotification(
                    "Invitation email resent successfully!",
                    "success"
                  );
                } else {
                  showNotification("Failed to resend invitation.", "error");
                }
              }}
              sx={{
                color: "var(--color-icon)",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.1)",
                },
              }}
            >
              <RefreshIcon />
            </IconButton>
          );
        }
        return null;
      },
    },
  ];

  // Ensure each row has a unique ID
  const rows = filteredOperators.map((op) => ({
    id: op.id,
    ...op,
  }));

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 30,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h1 className={styles.dashboardTitle}>OPERATORS</h1>
        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "center",
            minWidth: 0,
            flexWrap: "wrap",
          }}
        >
          <FormControlLabel
            labelPlacement="start"
            control={
              <Switch
                checked={statusFilter === "Enable"}
                onChange={() => {
                  const newFilter = statusFilter === "Enable" ? "Disable" : "Enable";
                  setStatusFilter(newFilter);
                  // When "Show Disabled" is toggled ON (newFilter="Enable"), fetch all including disabled (isActive=false)
                  // When toggled OFF (newFilter="Disable"), fetch only active (isActive=true)
                  fetchOperators(newFilter !== "Enable");
                }}
                sx={{
                  color: "var(--color-primary)",
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#43a047", // light green
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#43a047",
                  },
                }}
              />
            }
            label={
              <span
                style={{
                  fontSize: "0.875rem",
                  fontWeight: "600",
                  color: "var(--color-header)",
                }}
              >
                Show Disabled
              </span>
            }
          />
          <div
            style={{
              position: "relative",
              minWidth: 0,
              flex: "1 1 120px",
              width: "100%",
            }}
          >
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 24px 8px 40px",
                borderRadius: 4,
                border: "1px solid #ccc",
                fontSize: "0.98rem",
                width: "100%",
                height: 40,
                boxSizing: "border-box",
              }}
            />
            <span
              style={{
                position: "absolute",
                left: 12,
                top: "55%",
                transform: "translateY(-50%)",
                color: "#888",
                pointerEvents: "none",
              }}
            >
              <SearchIcon />
            </span>
          </div>

          <div style={{ position: "relative", display: "inline-block" }}>
            <Button
              type="submit"
              variant="contained"
              size="large"
              onClick={() => setShowAddModal(true)}
              sx={{
                width: "100%",
                backgroundColor: "var(--color-primary)",
                "&:hover": { backgroundColor: "var(--color-secondary)" },
              }}
            >
              Add Operator
            </Button>
          </div>
        </div>
      </div>
        <Paper sx={{ height: 580, width: "100%", borderRadius: 2, boxShadow: 2 , cursor: 'pointer'  }}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowHeight={36}
            onRowDoubleClick={(params) => handleEditOperator(params.row.id)}
            loading={loading}
            pageSizeOptions={[15, 30, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 15, page: 0 } },
            }}
            disableRowSelectionOnClick
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "14px",
                fontWeight: "bold",
              },
            }}
            localeText={{
              noRowsLabel: "No operators found",
              loadingOverlayLabel: "Loading operators...",
            }}
          />
        </Paper>
      {/* Add Operator Modal */}
      <Dialog
        open={showAddModal}
        onClose={() => (
          setShowAddModal(false),
          setNewOperator({ name: "", email: "", ownerClientId: "", payoutAmount: "" })
        )}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            minWidth: 300,
            maxWidth: 450,
            p: 1,
            position: "relative",
          },
        }}
      >
        {/* Absolute positioned close button */}
        <IconButton
          aria-label="close"
          onClick={() => (
            setShowAddModal(false),
            setNewOperator({ name: "", email: "", ownerClientId: "", payoutAmount: "" })
          )}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "var(--color-close-icon)",
            zIndex: 1,
          }}
        >
          <Cancel fontSize="small" />
        </IconButton>
        <DialogTitle sx={{ pr: 4 }}>
          <Typography
            variant="body2"
            fontWeight="bold"
            color="var(--color-primary)"
          >
            {"Add a New Operator".toUpperCase()}
          </Typography>
        </DialogTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleAddOperator();
          }}
        >
          <DialogContent sx={{ pt: 1 }}>
            {errors.name && (
              <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                {errors.name}
              </Typography>
            )}
            <TextField
              fullWidth
              size="small"
              label="Name"
              value={newOperator.name}
              onChange={(e) =>
                setNewOperator((prev) => ({ ...prev, name: e.target.value }))
              }
              error={!!errors.name}
              helperText={errors.name}
              required
              sx={{ mb: 2 }}
              autoFocus
            />
            <TextField
              fullWidth
              size="small"
              label="Email"
              type="email"
              value={newOperator.email}
              onChange={(e) =>
                setNewOperator((prev) => ({ ...prev, email: e.target.value }))
              }
              error={!!errors.email}
              helperText={errors.email}
              required
              sx={{ mb: 2 }}
            />
            <FormControl
              error={!!errors.ownerClientId}
              required
              size="small"
              fullWidth
              sx={{ mb: 2 }}
            >
              <InputLabel
                htmlFor="country-select"
                sx={{
                  transform: "translate(14px, 14px) scale(1)",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(14px, 0px) scale(0.75)",
                  },
                }}
              >
                Owner Client
              </InputLabel>
              <Select
                value={newOperator.ownerClientId}
                label="Owner Client"
                onChange={(e) =>
                  setNewOperator((prev) => ({
                    ...prev,
                    ownerClientId: e.target.value,
                  }))
                }
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                      overflowY: "auto",
                    },
                  },
                }}
              >
                {clients.map((client) => (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.ownerClientId && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 2, mt: 0.5 }}
                >
                  {errors.ownerClientId}
                </Typography>
              )}
            </FormControl>
            <TextField
              fullWidth
              required
              size="small"
              label="Payout Amount per Message"
              type="number"
              value={newOperator.payoutAmount}
              onChange={(e) => {
                const value = e.target.value;
                // Only allow 2 decimal places
                if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
                  setNewOperator((prev) => ({
                    ...prev,
                    payoutAmount: value,
                  }));
                }
              }}
              error={!!errors.payoutAmount}
              helperText={errors.payoutAmount || "Amount in pounds (£)"}
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: <Typography sx={{ mr: 1 }}>£</Typography>,
              }}
              inputProps={{ min: 0, step: 0.01 }}
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: "var(--color-primary)",
                "&:hover": { backgroundColor: "var(--color-secondary)" },
              }}
            >
              Create Operator
            </Button>
          </DialogContent>
        </form>
      </Dialog>

      {/* Notification */}
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
}
